import { Users } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, ConvertToCharacter, DropDownData, convertToNumber, deleteData, encryptPassword, sanitizeInput } from "../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData } from "../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBoxNew, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const BranchMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const data = CommonApiData();
    const initialFormData = {
        "branchCode": "System Generated",
        "branchID": "0",
        "branchName": "",
        "contactPerson": "",
        "mobileNo": "",
        "emailID": "",
        "address1": "",
        "address2": "",
        "city": "",
        "pinCode": "",
        "state": "",
        "active": true,
    }

    const [formData, setFormData] = useState(initialFormData);
    const GetGroupName = DropDownData('GetGroupNameUserWise', data.loginUserGroupID,)
    const groupList = GetGroupName?.data?.dropDownData || [];

    const GetBranchMaster = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let data = {
            ...formData,
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowBranchMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED' || res.Status === 'UNAUTHORIZED') {
            await NotificationSound(res.Status, res.Message, res?.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData(initialFormData);
        filterData.SearchText = '';
        inputrefs.current['txtBranchName'].focus()
        GetBranchMaster();
    }

    const GetCityStateByPincode = async (dataPayload) => {
        await dispatch(setSubLoading(true));
        let data = await ApiCall(`/api/Master/GetCityStateByPincode`, dataPayload);
        await dispatch(setSubLoading(false));
        if (data?.city || data?.state) {
            setFormData(prev => ({
                ...prev,
                city: data?.city || "",
                state: data?.state || ""
            }));
        }
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateBranchMaster`, { ...formData, password: encryptPassword(formData.password) })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data?.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditBranchMaster`, { BranchID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'SUCCESS') {
            setFormData((pre) => ({
                ...pre, ...editData,
            }))
            await inputrefs.current[editData?.focus].focus();
        } else {
            await NotificationSound(editData.status, editData.message, editData?.focus, inputrefs);
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteBranchMaster`, { BranchID: id }, GetBranchMaster, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (i, p) => {
        GetBranchMaster(p)
    };

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };


    useEffect(() => {
        document.title = `Branch Master`
        inputrefs.current['txtBranchName'].focus()
    }, [])

    useEffect(() => {
        GetBranchMaster();
    }, [sortConfig]);

    return (
        <>
            <div className='bg-secondary-50 shadow-lg rounded-md p-3'>
                <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                        <Users className="w-5 h-5 text-primary-600" />
                        <h2 className="text-xl font-semibold text-primary-600">Branch Master</h2>
                    </div>
                </div>
                <div className="card-body grid grid-cols-1 md:grid-cols-4 gap-3">
                    <InputBox
                        id="txtBranchCode"
                        label="Branch Code"
                        placeholder="Enter Branch Code"
                        value={formData.branchCode}
                        disabled
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtBranchName'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtBranchName"
                        label="Branch Name"
                        placeholder="Enter Branch Name"
                        required
                        value={formData.branchName}
                        onChange={(e) =>
                            setFormData({ ...formData, branchName: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtPinCode'].focus()
                            }
                        }}
                    />

                    <AutoCompleteBoxNew
                        id="txtPinCode"
                        label="Pincode"
                        placeholder="Enter Pincode"
                        autocompleteType="GetPinCode"
                        value={formData.pinCode || ""}
                        onChange={async (event, newInputValue) => {
                            newInputValue = newInputValue || '';

                            if (event.type !== 'keydown') {
                                const updatedData = { ...formData, pinCode: newInputValue };
                                setFormData(updatedData);
                                GetCityStateByPincode(updatedData);
                            }
                        }}
                        required
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtState'].focus()
                            }
                        }}
                    />
                    <AutoCompleteBoxNew
                        id="txtState"
                        label="State"
                        placeholder="Select State"
                        autocompleteType="GetState"
                        value={formData.state}
                        onChange={(e, val) =>
                            setFormData({ ...formData, state: val || "" })
                        }
                        required
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtCity'].focus()
                            }
                        }}
                    />
                    <AutoCompleteBoxNew
                        id="txtCity"
                        label="City"
                        placeholder="Select City"
                        autocompleteType="GetCity"
                        contextKey={formData.state}
                        value={formData.city}
                        onChange={(e, val) =>
                            setFormData({ ...formData, city: val || "" })
                        }
                        required
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtAddress1'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtAddress1"
                        label="Address1"
                        placeholder="Enter Address1"
                        value={formData.address1}
                        onChange={(e) =>
                            setFormData({ ...formData, address1: sanitizeInput(e.target.value) })
                        }
                        required
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtAddress2'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtAddress2"
                        label="Address2"
                        placeholder="Enter Address2"
                        value={formData.address2}
                        onChange={(e) =>
                            setFormData({ ...formData, address2: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtContactPerson'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtContactPerson"
                        label="Contact Person"
                        placeholder="Enter Contact Person"
                        value={formData.contactPerson}
                        onChange={(e) =>
                            setFormData({ ...formData, contactPerson: ConvertToCharacter(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtMobileNo'].focus()
                            }
                        }}
                    />
                    <InputBox
                        id="txtMobileNo"
                        label="Mobile No"
                        placeholder="Enter Mobile No"
                        maxLength="10"
                        value={formData.mobileNo}
                        onChange={(e) =>
                            setFormData({ ...formData, mobileNo: convertToNumber(e.target.value) })
                        }
                        required
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtEmailID'].focus()
                            }
                        }}
                    />

                    <InputBox
                        id="txtEmailID"
                        type="email"
                        required
                        label="Email ID"
                        placeholder="Enter Email ID"
                        value={formData.emailID}
                        onChange={(e) =>
                            setFormData({ ...formData, emailID: sanitizeInput(e.target.value) })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['txtActive'].focus()
                            }
                        }}
                    />
                    <Switch
                        id="txtActive"
                        label="Active"
                        checked={formData.active}
                        onChange={(e) =>
                            setFormData({ ...formData, active: e.target.checked })
                        }
                        inputrefs={inputrefs}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                inputrefs.current['btnSub'].focus()
                            }
                        }}
                        divclassname="mt-2"
                    />

                </div>

                <div className='card-body'>
                    <FormButton
                        id={'btnSub'}
                        inputrefs={inputrefs}
                        handleSubmit={handleSubmit}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            handleDownloadExcel(`/api/Master/ShowBranchMaster`, filterData, 'Branch Master')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                </div>

            </div>

            <div className=" mt-3">
                <Table
                    handleEdit={handleEditData}
                    handleDelete={handleDelete}
                    loading={isLoading}
                    PageName={'BranchMaster'}
                    handleFilter={() => {
                        GetBranchMaster()
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    sortConfig={sortConfig}
                    handleSorting={handleSorting}
                />
            </div>
        </>
    )
}
export default BranchMaster;